/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Popup utility used with zoom_authorization route
namespace('Slzr', function(exports, top) {
  const $ = Slzr.jQuery;

  // WP_CHANGE: i18n definitions comes from en.yml:489
  const MESSAGES = {
    authorize_and_create_meeting: 'Create Zoom Meeting',
    create_meeting: 'Create Zoom Meeting',
    create_meeting_progress: 'Creating Zoom Meeting...',
    create_meeting_error: 'There was a problem creating the meeting. Please try again',
    delete_meeting: 'Delete Zoom Meeting',
    delete_meeting_progress: 'Deleting Zoom Meeting...',
    delete_meeting_error: 'There was a problem deleting the meeting. Please try again',
    need_reauthorize_error: 'You must reconnect your Zoom account. Please try again to do so',
    delete_confirmation: 'Are you sure you want to delete this Zoom meeting? This cannot be undone.'
  };


  return exports.ZoomConnect = class ZoomConnect {
    constructor(state, event_id, has_zoom_integration) {
      this.updateTitleData = this.updateTitleData.bind(this);
      this.updateTimeData = this.updateTimeData.bind(this);
      this.updateUrlDisplay = this.updateUrlDisplay.bind(this);
      this.updateState = this.updateState.bind(this);
      this.connect = this.connect.bind(this);
      this.connected = this.connected.bind(this);
      this.create = this.create.bind(this);
      this.destroy = this.destroy.bind(this);
      this.getElement = this.getElement.bind(this);
      this.setStreamService = this.setStreamService.bind(this);
      this.setStreamServiceId = this.setStreamServiceId.bind(this);
      this.setStreamUrl = this.setStreamUrl.bind(this);
      this.setPublishAccessTokenId = this.setPublishAccessTokenId.bind(this);
      this.setDescription = this.setDescription.bind(this);
      this.clearDescription = this.clearDescription.bind(this);
      this.setStreamServiceError = this.setStreamServiceError.bind(this);
      this.clearStreamServiceError = this.clearStreamServiceError.bind(this);
      this.hideAllLinks = this.hideAllLinks.bind(this);
      this.setProgressMessage = this.setProgressMessage.bind(this);
      this.clearProgressMessage = this.clearProgressMessage.bind(this);
      this.createMeeting = this.createMeeting.bind(this);
      this.destroyMeeting = this.destroyMeeting.bind(this);
      this.state = state;
      
      this.event_id = !event_id || ((event_id != null ? event_id.trim() : undefined) === "null") ?
                        ""
                      :
                        event_id;
      
      if (has_zoom_integration) {
        this.authLink = this.getElement("authorize_and_create_zoom_meeting_link");
        if (this.authLink != null) {
          this.authLink.addEventListener("click", this.connect);
        }
        this.authorize_and_create_wrapper = this.getElement("authorize_and_create_zoom_meeting");
        
        this.meetingLink = this.getElement("create_zoom_meeting_link");
        if (this.meetingLink != null) {
          this.meetingLink.addEventListener("click", this.create);
        }
        this.create_wrapper = this.getElement("create_zoom_meeting");
        
        this.destroyLink = this.getElement("delete_zoom_meeting_link");
        if (this.destroyLink != null) {
          this.destroyLink.addEventListener("click", this.destroy);
        }
        this.destroy_wrapper = this.getElement("delete_zoom_meeting");
        
        this.updateUrlDisplay();
      }
    }

    /**
     * Update the title stored on meetingLink
     *
     * @param {String} new_title The new meeting title
    */
    updateTitleData(new_title) {
      return (this.meetingLink != null ? this.meetingLink.dataset.title = new_title : undefined);
    }

    /**
     * Update the start time and duration data stored on meetingLink
     *
     * @param {EventInstanceManager} event_instance_manager The EventInstanceManager instance to update data from
    */
    updateTimeData(event_instance_manager) {
      if ((event_instance_manager != null) && (this.meetingLink != null)) {
        const next_instance = event_instance_manager.nextInstanceAt();
        const duration = event_instance_manager.nextInstanceDurationMinutes();
        this.meetingLink.dataset.startTime = next_instance ? next_instance.toJSON() : '';
        return this.meetingLink.dataset.duration = duration > 0 ?
                                              duration
                                            : __guard__(event_instance_manager.nextInstance(), x => x.start_time) === '' ?
                                              // All day events, 24 hours
                                              24 * 60
                                            :
                                              // No end time, default to 60 minutes (matches Zoom's default)
                                              60;
      }
    }


    updateUrlDisplay() {
      if (this.state === "no_meeting") {
        if (this.authorize_and_create_wrapper != null) {
          this.authorize_and_create_wrapper.style.display = "none";
        }
        if (this.create_wrapper != null) {
          this.create_wrapper.style.display = "block";
        }
        return (this.destroy_wrapper != null ? this.destroy_wrapper.style.display = "none" : undefined);
      } else if (this.state === "meeting") {
        if (this.authorize_and_create_wrapper != null) {
          this.authorize_and_create_wrapper.style.display = "none";
        }
        if (this.create_wrapper != null) {
          this.create_wrapper.style.display = "none";
        }
        return (this.destroy_wrapper != null ? this.destroy_wrapper.style.display = "block" : undefined);
      } 
        if (this.authorize_and_create_wrapper != null) {
          this.authorize_and_create_wrapper.style.display = "block";
        }
        if (this.create_wrapper != null) {
          this.create_wrapper.style.display = "none";
        }
        return (this.destroy_wrapper != null ? this.destroy_wrapper.style.display = "none" : undefined);
      
    }
    
    updateState(state) {
      this.state = state;
      return this.updateUrlDisplay();
    }
    
    // Show auth popup
    connect(e){
      e.preventDefault();
      
      const windowFeatures = "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,height=600, width=600";
      
      return this.popup = window.open("/zoom/connect", "Authorize", windowFeatures);
    }
    
    // Called after user has been redirected to /zoom_authorization/connected from zoom authorization
    connected() {
      const target = document.getElementById('create_zoom_meeting_link');
      return this.createMeeting(target.dataset.title, "authorize_and_create_meeting_link", target.dataset.startTime, target.dataset.duration);
    }
        
    create(e) {
      e.preventDefault();
      return this.createMeeting(e.target.dataset.title, "create_zoom_meeting_link", e.target.dataset.startTime, e.target.dataset.duration);
    }
    
    destroy(e) {
      e.preventDefault();
      return this.destroyMeeting(e.target.dataset.meetingId, "create_zoom_meeting_link");
    }
      
    getElement(id) {
      return document.getElementById(id);
    }
    
    setStreamService(text) {
      const event_stream_service = this.getElement("event_stream_service");
      return event_stream_service.value = text;
    }

    setStreamServiceId(id) {
      const event_stream_service_id = this.getElement("event_stream_service_id");
      return event_stream_service_id.value = id;
    }

    triggerChangeEvent(element) {
      let event = null;
      // IE doesn't support new Event
      if (typeof('Event') === 'function') {
        event = new Event('change', {bubbles: true, cancelable: true});
      } else {
        event = document.createEvent('Event');
        event.initEvent('change', true, true);
      }

      return element.dispatchEvent(event);
    }

    setStreamUrl(url) {
      const event_stream_url = this.getElement("event_stream_url");
      event_stream_url.value = url;
      return this.triggerChangeEvent(event_stream_url);
    }

    setPublishAccessTokenId(id) {
      const event_publish_access_token_id = this.getElement("event_publish_access_token_id");
      return event_publish_access_token_id.value = id;
    }
    
    setDescription(text) {
      text = text.split("\n").slice(6).join("\n");
      return CKEDITOR.instances.event_stream_info.insertText(text);
    }
    
    clearDescription() {
      return CKEDITOR.instances.event_stream_info.setData("");
    }
    
    setStreamServiceError(message) {
      const stream_service_error = this.getElement("stream_service_error");
      return stream_service_error.innerHTML = message;
    }
    
    clearStreamServiceError() {
      const stream_service_error = this.getElement("stream_service_error");
      return stream_service_error.innerHTML = "";
    }

    hideAllLinks(e) {
      if (this.authorize_and_create_wrapper != null) {
        this.authorize_and_create_wrapper.style.display = "none";
      }
      if (this.create_wrapper != null) {
        this.create_wrapper.style.display = "none";
      }
      return (this.destroy_wrapper != null ? this.destroy_wrapper.style.display = "none" : undefined);
    }
    
    setProgressMessage(message) {
      this.hideAllLinks();
      const token_id = this.getElement("authorize_and_create_zoom_meeting");
      return token_id.insertAdjacentHTML("beforebegin", `<div id='zoom-notification'>${  message  }</div>`);
    }
    
    clearProgressMessage() {
      const element = this.getElement('zoom-notification');
      return element.parentNode.removeChild(element);
    }
    
    createMeeting(title, linkId, start_time = null, duration = null) {
      this.clearStreamServiceError();
      this.setProgressMessage(MESSAGES.create_meeting_progress);
      
      if (!title) { title = ""; }
      
      const that = this;
      
      return $.ajax({
        url: "/zoom_meetings",
        type: "POST",
        dataType: "json",
        data: { 
          title,
          start_time,
          duration,
          event_id: that.event_id
        },
        success(data, status, jqXHR) {
          if (data.status === 'error') {
            // Error returned from Zoom

            // Update status and error messaging based on the response from Zoom
            let error_message;
            switch (data.code) {
              // 124 is "Invalid access token"
              case 'invalid_request': case 124:
                error_message = MESSAGES.need_reauthorize_error;
                that.updateState('unauthorized');
                break;
              default:
                error_message = `${MESSAGES.create_meeting_error} (${data.code}: ${data.message})`;
            }

            that.clearProgressMessage();
            return that.setStreamServiceError(error_message);

          } else if (data.status === "created") {
            // Zoom Meeting created successfully
            that.setStreamService("zoom");
            that.setStreamServiceId(data.id);
            that.setStreamUrl(data.join_url);
            that.setPublishAccessTokenId(data.publish_access_token_id);
            that.destroyLink.dataset.meetingId = data.id;
            that.setDescription(data.invitation);
            that.clearStreamServiceError();
            that.clearProgressMessage();

            return that.updateState("meeting");
          } 
            that.setStreamService("");
            that.setStreamServiceId("");
            that.setStreamUrl("");
            that.setPublishAccessTokenId("");
            delete that.destroyLink.dataset.meetingId;
            that.clearDescription();
            that.clearProgressMessage();

            console.error("Error creating meeting: ", data.status, data.message);
            return that.setStreamServiceError(MESSAGES.create_meeting_error);
          
        },

        error(jqXHR, status, errorMessage) {
          console.error("Server error creating meeting: ", status, errorMessage);
          that.clearProgressMessage();
          return that.setStreamServiceError(MESSAGES.create_meeting_error);
        }
      });
    }
    
    destroyMeeting(id) {
      if (confirm(MESSAGES.delete_confirmation)) {
        this.clearStreamServiceError();
        this.setProgressMessage(MESSAGES.delete_meeting_progress);

        const path = `/zoom_meetings/${  id}`;
        
        const that = this;
        
        return $.ajax({
          url: path,
          type: "DELETE",
          dataType: "json",
          data: {
            event_id: that.event_id
          },
          success(data, status, jqXHR) {
            if (data.status === 'error') {
              // Error returned from Zoom

              // Update status and error messaging based on the response from Zoom
              let error_message;
              switch (data.code) {
                // 124 is "Invalid access token"
                case 'invalid_request': case 124:
                  error_message = MESSAGES.need_reauthorize_error;
                  that.updateState('unauthorized');
                  break;
                default:
                  error_message = `${MESSAGES.delete_meeting_error} (${data.code}: ${data.message})`;
              }

              that.clearProgressMessage();
              return that.setStreamServiceError(error_message);

            } else if (data.status === "deleted") {
              that.setStreamService("");
              that.setStreamServiceId("");
              that.setStreamUrl("");
              that.setPublishAccessTokenId("");
              delete that.destroyLink.dataset.meetingId;
              that.clearDescription();
              that.clearStreamServiceError();
              that.clearProgressMessage();

              return that.updateState("no_meeting");
            } 
              that.clearProgressMessage();
              console.error("Error deleting meeting: ", data.status, data.message);
              return that.setStreamServiceError(MESSAGES.delete_meeting_error);
            
          },

          error(jqXHR, status, errorMessage) {
            console.error("Server error removing meeting: ", status, errorMessage);
            that.clearProgressMessage();
            return that.setStreamServiceError(MESSAGES.delete_meeting_error);
          }
        });
      }
    }
  };
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}